import { z } from "zod";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedRuleEstablishment.errors.";

// Regra para o item selecionado no AutoComplete
const establishmentSelectSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
  },
  { invalid_type_error: translationPath + "establishment_field" },
);

// Schema principal do formulário
export const establishmentsSchema = z.object({
  id: z.string().optional(),
  establishment: establishmentSelectSchema, // Apenas para a seleção no combo
  establishmentName: z
    .string()
    .min(1, { message: translationPath + "name_required" }), // O input de texto do apelido
});

export type TEstablishmentsForm = z.infer<typeof establishmentsSchema>;

export interface IEstablishmentsProps {
  id?: string;
  ticketAutomationReceivedRuleId?: string;
  automationCode?: string;
  TEstablishmentsForm?: string;
  onBackButton: () => void;
}
